import React from "react";
import { useCart } from "hooks/useStore";
import useToggle from "hooks/useToggle";
import { CHECKOUT_DOMAIN } from "utils/constants";
import { setConvertAttrToCookie } from "helpers/convert";
import clsx from "clsx/lite";

const CheckoutButton = ({ showEmptyCartSummary }) => {
	const [loading, toggleLoading] = useToggle();
	const { checkoutUrl, totalQuantity, updateBuyerIdentity } = useCart(["checkoutUrl", "totalQuantity", "updateBuyerIdentity"]);
	const hasItemsInCart = totalQuantity > 0;

	const handleCheckout = async () => {
		if (!hasItemsInCart) return;
		toggleLoading();
		setConvertAttrToCookie();
		await updateBuyerIdentity();
		if (checkoutUrl) {
			window.location.href = checkoutUrl.replace(new URL(checkoutUrl).hostname, CHECKOUT_DOMAIN);
		}
		setTimeout(toggleLoading, 1000);
	};

	return (
		<button
			disabled={loading || !hasItemsInCart}
			onClick={handleCheckout}
			className={clsx("btn btn-primary w-full text-center", showEmptyCartSummary ? "py-3.5 md:!py-5" : "py-4")}
		>
			{loading ? "Checking out..." : "Checkout"}
		</button>
	);
};

export default CheckoutButton;